import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Grid, Row, Col, Panel, Button, Breadcrumb, ButtonToolbar } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import Spinner from '../../components/Widgets/spinner';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { Toolbar, Data } from 'react-data-grid-addons';
import { SkyLightStateless } from 'react-skylight';
import  AdjustInventoryForm from "../../containers/Inventories/adjustInventoryForm";
import AdjustmentLog from "../../containers/Inventories/adjustmentLog";
import { companyCodeTitle } from '../../actions/root_url';


class AdjustmentInventory extends Component {
  constructor() {
    super();
    this.state = {
      stuff: null,
      rows: [],
      selectedRows: [],
      enabledRow: null,
      newRows: [],
      filters: {},
      save: false,
      saveOpen: false,
      creating: false,
      deleting: false,
      editing: false,
    };
  }

  componentWillMount = () => {
    this.props.fetchReasons()
    .then(() => this.setState({rows: this.props.reasons}));
  }

  componentDidMount() {
    document.title = companyCodeTitle;
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.deleted && this.props.deleted !== prevProps.deleted) {
      this.props.fetchReasons()
      .then(() => this.setState({rows: this.props.reasons}));
    }

    if (this.props.edited && this.props.edited !== prevProps.edited) {
      this.closeEdit();
      this.props.fetchReasons()
      .then(() => this.setState({rows: this.props.reasons}));
    }

    if (this.props.created && this.props.created !== prevProps.created) {
      this.closeCreate();
      this.props.fetchReasons()
      .then(() => this.setState({rows: this.props.reasons}));
    }
  }

  closeCreate = () => {
    this.setState({creating: false})
  }

  openCreate = () => {
    this.setState({ creating: true });
  }

  closeEdit = () => {
    this.setState({editing: false});
  }

  openEdit = () => {
    this.setState({editing: true})
  }

  closeDelete = () => {
    this.setState({deleting: false})
  }

  openDelete = () => {
    this.setState({ deleting: true})
  }

  deleteReason = (e) => {
    e.preventDefault();
    let id = this.state.selectedRows[0].id;
    this.props.deleteReason(id);
    this.closeDelete();
  }

  editReason = (e) => {
    e.preventDefault();
    const {selectedRows} = this.state;
    this.props.resetCurrentReason();
    const currentReason = selectedRows[0];
    this.props.selectReason(currentReason)
    this.openEdit();
  }

  createReason = (e) => {
    e.preventDefault();
    this.props.resetCurrentReason();
    this.openCreate();
  }

    renderTable = () => {
      if (this.props.isLoading && !this.props.error) return <Spinner />;
      else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{this.props.error}</div></ContentWrapper>
    
    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () =>  getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({ Idx: rowIdx }, rows[rowIdx]);
    };

    const handleFilterChange = filter => {
      const newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({ filters: newFilters });
    };

    const onRowsSelected = (rows) => {
      let newRows = getRows();
      let selectedRows = [newRows[rows[0].rowIdx]];
      let zoneId = rows[0].row.WarehouseZone_id
      newRows.map(r => {
        r.isSelected = false;
      });
      rows.map(r => {
        newRows[r.rowIdx].isSelected = true;
      });
      this.setState({ selectedRows: selectedRows });
    };

    const onRowsDeselected = (rows) => {
      let rowIndexes = rows.map(r => r.rowIdx);
      let newRows = [...this.state.rows];
      rows.map (r => {
        newRows[r.rowIdx].isSelected = false;
      });
      this.setState({ rows: newRows, selectedRows: [] });
    };

    const columns = [
      {
        key: 'ReasonDesc',
        name: <Translate value='reason'/>,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 450
      },
    ];

    return (
      <Row>
        <Col sm={12}>
          <div style={{maxWidth: '99%'}} id="ProductConvert-dataGrid2">
            <ReactDataGrid 
              rowkey='id'
              enableCellSelect
              toolbar={<Toolbar enableFilter />}
              columns={columns}
              onAddFilter={handleFilterChange}
              headerRowHeight={60}
              rowHeight={45}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={570}
              rowSelection={{
                showCheckbox: true,
                onRowsSelected,
                onRowsDeselected,
                selectBy: {
                  isSelectedKey: 'isSelected',
                },
              }}
            />
          </div>
        </Col>
      </Row>
    );
    }

    render() {
      return (
        <ContentWrapper>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="warehouse_management" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active='true'>
              <Translate value="inventory_adjustment" />
            </Breadcrumb.Item>
          </Breadcrumb> 

            <Row sm={12}>
            <Col sm={4}>
            <Panel style={{marginTop: 30}} header ={<Translate value="reason_management"/>} id="category2-detail">
              <ButtonToolbar>
                <Button
                bsStyle="success"
                type="button"
                onClick={(e) => this.createReason(e)}
                >
                  <em className="fa fa-plus" /><Translate value="create"/>
                </Button>
                <Button
                bsStyle="warning"
                type="button"
                onClick={(e) => this.editReason(e)}
                >
                  <em className="fa fa-pencil" /><Translate value="edit"/>
                </Button>
                <Button
                bsStyle="danger"
                type="button"
                onClick={this.openDelete}
                >
                  <em className="fa fa-trash-o" /><Translate value="delete"/>
                </Button>
              </ButtonToolbar>
              {this.renderTable()}
            </Panel>
              </Col>
              <Col sm={8}>
              <AdjustmentLog/>
              </Col>
            </Row>

        <SkyLightStateless 
          onCloseClicked={() => this.closeCreate()}
          title="Create Reason"
          isVisible={this.state.creating}
        >
         <AdjustInventoryForm 
          closeG={this.closeCreate}
         /> 
          
        </SkyLightStateless>

        <SkyLightStateless 
          onCloseClicked={() => this.closeEdit()}
          title="Edit Reason"
          isVisible={this.state.editing}
        >
         <AdjustInventoryForm 
          closeG={this.closeEdit}
         /> 
        </SkyLightStateless>
        <SkyLightStateless 
          onCloseClicked={() => this.closeDelete()}
          title="Delete Reason?"
          isVisible={this.state.deleting}
        > 
         <br/><br/>
          <Row className="centerStyle"><h4><Translate value="delete" /></h4></Row>
          <br/><br/>
          <Row className="text-center">
            <Button onClick={(e) => this.deleteReason(e)}   className="text-center" bsStyle="primary" type="button"><Translate value="yes"/></Button>
            <Button onClick={this.closeDelete} className="text-center" bsStyle="danger" type="button"><Translate value="no"/></Button>
          </Row>
        </SkyLightStateless>
      </ContentWrapper>
    );
  }
}

export default AdjustmentInventory;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/adjustmentInventory.jsx